import React from 'react';
import { MoveTypes } from '../../../api/Inventory/Entities/InventoryMovementEntities';
import { useTranslation } from 'react-i18next';
import { Assigments } from '../../../api/Inventory/Entities/InventoryEntities';
import { InventoryLaboratoryKitMoveForm } from '../Shared/InventoryLaboratoryKitMoveForm';

export function AddStockLaboratoryKitPage({ match: { params } }) {
    const { t } = useTranslation();

    return (<>
        <InventoryLaboratoryKitMoveForm
            title={t('inventory.movements.commons.stockEntryByLaboratoryKit')}
            moveId={params.moveId ?? 0}
            moveType={MoveTypes.AddStock.Name}
            assignmentType={Assigments.ProtocolLaboratoryKit} />
    </>)
}